<div class="sidenav-fixed" [ngClass]="sideBarIsOpened ? '' : 'enlarge-menu'">

<app-header (toggleMenuClick)="setSidebarState(null)"></app-header>

<div class="page-wrapper">
    <!-- Left Sidenav -->
     <div class="left-sidenav">
        <p-panelMenu [model]="items" styleClass="w-full left-sidenav-menu" [multiple]="true">
            <ng-template pTemplate="item" let-item>
                <ng-container *ngIf="item.route; else urlRef">
                    <a [routerLink]="item.route" class="flex align-items-center cursor-pointer menu-item px-3 py-2" [ngClass]="{'active-menu-item': item.active}">
                        <fa-icon [icon]="item.faIcon"></fa-icon>
                        <span class="ml-2">{{ item.label }}</span>
                    </a>
                </ng-container>
                <ng-template #urlRef>
                    <a *ngIf="item.url; else noLink" [href]="item.url" class="flex align-items-center cursor-pointer menu-item px-3 py-2">
                        <fa-icon [icon]="item.faIcon"></fa-icon>
                        <span class="ml-2">{{ item.label }}</span>
                    </a>
                    <ng-template #noLink>
                        <span class="flex align-items-center cursor-pointer px-3 py-2 menu-item" (click)="onPanelExpand(item)">
                            <fa-icon [icon]="item.faIcon"></fa-icon>
                            <span class="ml-2">{{ item.label }}</span>
                            <i *ngIf="item.items" class="pi ml-auto" [ngClass]="{'pi-angle-down': item.expanded, 'pi-angle-right': !item.expanded}"></i>
                        </span>
                    </ng-template>
                </ng-template>
            </ng-template>
        </p-panelMenu>
    </div>
    <!-- end left-sidenav-->

    <!-- Page Content-->
    <div class="page-content">
        <p-messages *ngIf="isStaging" severity="warn">
            <ng-template pTemplate>
                <span class="p-message-summary" i18n>Testing version</span>
                <span class="p-message-detail" i18n>This is testing version of nextbike swissknife, no changes applied here will be persisted into live version.</span>
            </ng-template>
        </p-messages>
        <div class="container-fluid">
            <router-outlet></router-outlet>
        </div><!-- container -->

        <footer class="footer text-center text-sm-left">
            <span class="text-muted d-none d-sm-inline-block float-right">Crafted with <fa-icon [icon]="faHeart"></fa-icon> by Adam Schubert</span>
        </footer><!--end footer-->
    </div>
    <!-- end page content -->
</div>
<!-- end page-wrapper -->

</div>
